import { Icon } from "../Icon"

interface CloseIconProps {
  size?: number
  className?: string
}

export const CloseIcon = ({ size = 18, className }: CloseIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 18 18" className={className}>
      <path
        d="M13.75 4.25L4.25 13.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 4.25L13.75 13.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
